import axios from "../axiosInstance"
import type { FmvStagingRecord } from "@/types/company"

export const getFmvStaging = async (id: number): Promise<FmvStagingRecord> => {
  const res = await axios.get(`/fmv-staging/${id}`)
  if (!res.data.success) {
    throw new Error(res.data.error || "Failed to fetch staging record")
  }
  return res.data.staging
}

export type ConfirmPayload = {
  companyId?: number
  fmvValue?: number
  fmvDate?: string
  fmvSource?: string
  fileLabel?: string
  folderPath?: string
}

export const getFmvStagingPreview = async (id: number): Promise<string> => {
  const res = await axios.get(`/fmv-staging/${id}/preview`, { responseType: "text" })
  return res.data as string
}

export const confirmFmvStaging = async (id: number, data: ConfirmPayload) => {
  const res = await axios.post(`/fmv-staging/${id}/confirm`, data)
  if (!res.data.success) {
    throw new Error(res.data.error || "Failed to confirm staging record")
  }
  return res.data
}
